import { removeQuery as N, queryGet as A } from "../../../common-lib/utils/query.js";
import { QUERY as m } from "../../constants/query.js";
import { useConfigContext as k } from "../config/ConfigContext.js";
import D from "../../hooks/generic/usePersistQuery.js";
import F from "../../hooks/graphql/useCheckInviter.js";
import G from "../../hooks/graphql/useGetBelievedInviter.js";
import Q from "../../hooks/graphql/useSendBelieveInviter.js";
import { isFullInviteCode as _ } from "../../util/adeptus/index.js";
import { createStrictContext as g } from "../../util/context/createStrictContext.js";
import { useRouter as q } from "next/router";
import * as e from "ramda";
import { useMemo as E, useState as d, useCallback as y, useEffect as B } from "react";
import { jsx as M } from "react/jsx-runtime";
const [T, te] = g("Adeptus"), se = (P) => {
  var h;
  const {
    children: x
  } = P, t = q(), {
    config: s
  } = k(), a = E(() => {
    var r;
    return ((r = s == null ? void 0 : s.adeptus) == null ? void 0 : r.autoBelievePaths) || [];
  }, [(h = s == null ? void 0 : s.adeptus) == null ? void 0 : h.autoBelievePaths]), {
    fetch: v
  } = G(), {
    fetch: p
  } = F(), {
    mutate: f
  } = Q(), [o, O] = d(""), [c, R] = d(null), [S, l] = d(null);
  D([m.INVITE_CODE]);
  const I = E(() => e.isNil(a) ? [] : e.map(N, a), [a]), i = y(async () => {
    if (t && e.includes(N(t.asPath), I)) {
      const {
        query: r
      } = t, u = A(r, m.CAMPAIGN_ID), n = A(r, m.INVITE_CODE);
      if (e.isNotNil(o) && e.isNotEmpty(o) && e.isNotNil(u) && e.isNotEmpty(u) && e.isNotNil(n) && _(n)) {
        const b = await v({
          id: u,
          address: o
        });
        if (e.pathOr("", ["invitation", "code"], b) !== n) {
          const C = await p(n);
          e.isNil(C) || await f({
            id: u,
            code: n,
            address: o
          }) && l(C);
        }
      }
    }
  }, [f, p, v, t, I, o]), w = y(() => {
    c && l(c);
  }, [c]);
  return B(() => {
    i();
  }, [i]), B(() => {
    if (e.isNotNil(t))
      return t.events.on("routeChangeComplete", i), () => {
        t.events.off("routeChangeComplete", i);
      };
  }, [i, t]), /* @__PURE__ */ M(T, {
    value: {
      inviter: c,
      successInviter: S,
      handleOnInviteSuccess: w,
      setInviter: R,
      setSuccessInviter: l,
      setWalletAddress: O
    },
    children: x
  });
};
export {
  se as AdeptusProvider,
  te as useAdeptusContext
};
//# sourceMappingURL=AdeptusContext.js.map
